import { render, staticRenderFns } from "./ModalDeleteProfile.vue?vue&type=template&id=13e0bcb2&"
import script from "./ModalDeleteProfile.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports